<script setup lang="ts">
import { useForm } from "@soft-db/form";
import { Checkbox } from "@soft-db/ui";
import { z } from "zod";
import PasswordField from "../common/PasswordField.vue";

const props = defineProps<{
	label?: string;
	username?: string;
	inputClass?: string;
	showEula?: boolean;
}>();
const emits = defineEmits<{ (e: "update:password", password: string): void }>();

const { t } = useI18n();

const { useField, handleSubmit, valid } = useForm<{
	password: string;
	confirmPassword: string;
	eula: boolean;
}>();

const password = useField("password", {
	isRequired: true,
	min: 8,
});

const eula = useField("eula", {
	schema: props.showEula ? z.literal(true) : undefined,
});

const updatePassword = handleSubmit((value) => {
	if (valid.value) {
		emits("update:password", value.password);
	}
});
</script>

<template>
	<form @submit="updatePassword">
		<input class="hidden" :value="username" type="username" />
		<PasswordField
			v-bind="password.attrs"
			:inputClass="inputClass"
			:label="t('common.password')"
			autocomplete="new-password"
		/>
		<div class="text-primary-content/80 mt-2 flex items-center gap-2">
			<Checkbox
				v-model="eula.data.value"
				size="sm"
				class="border-white text-white hover:border-white/20 data-[state=checked]:border-white/20 data-[state=checked]:bg-white/20"
			/>
			<div>
				I agree to the
				<router-link class="font-semibold underline" :to="{ name: 'eula' }" target="_blank">
					EULA and Terms & Conditions.
				</router-link>
			</div>
		</div>
		<div class="mt-4 flex">
			<SoftButton class="ml-auto" color="secondary" :disabled="!valid" type="submit">
				{{ label }}
			</SoftButton>
		</div>
	</form>
</template>
